import apiClient from "@/utils/httpClient";
import type { CreateVirtualPLEntryDto, VirtualPLEntryDto } from "@blinkbooks/types";

export const listVirtualPLEntries = (): Promise<VirtualPLEntryDto[]> =>
  apiClient.get<VirtualPLEntryDto[]>("/virtual-pl-entries");

export const createVirtualPLEntry = (data: CreateVirtualPLEntryDto): Promise<VirtualPLEntryDto> =>
  apiClient.post<VirtualPLEntryDto>("/virtual-pl-entries", data);

export const deleteVirtualPLEntry = (id: string): Promise<void> =>
  apiClient.delete(`/virtual-pl-entries/${id}`);
